import { render, staticRenderFns } from "./SubstancesSection.vue?vue&type=template&id=4e52f691&scoped=true&"
import script from "./SubstancesSection.vue?vue&type=script&lang=js&"
export * from "./SubstancesSection.vue?vue&type=script&lang=js&"
import style0 from "./SubstancesSection.vue?vue&type=style&index=0&id=4e52f691&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e52f691",
  null
  
)

export default component.exports